import { createContext } from "react";

export const UniversalDescriptorContext = createContext({
  universalDescriptors: [],
  refreshUniversalDescriptorContext: async () => {},
});
